module.exports = __webpack_public_path__ + "img/devCpp.cf8f7a47.png";